// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#openbay div.offer-pane ul{padding:0;list-style:none}#openbay div.offer-pane ul li{font-size:1rem;list-style:none;margin-bottom:.5rem}#openbay div.offer-pane .offer-pane-price{margin-right:1rem}#openbay div.offer-pane .offer-pane-price+a{font-weight:500}#openbay .offer-details-pane-modal section.detail-line-items:first-child{border-top:none}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
